import React, { useState } from 'react';
import { motion } from 'framer-motion';

export default function NewsletterSection() {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle');

    const handleSubmit = (e) => {
        e.preventDefault();
        setStatus('loading');
        setTimeout(() => {
            setStatus('success');
            setEmail('');
        }, 1500);
    };

    return (
        <section style={{ padding: '60px 40px 20px', background: 'var(--bg-surface)', borderTop: '1px solid var(--border)' }}>
            <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                >
                    <h2 style={{ fontSize: '48px', fontWeight: '800', letterSpacing: '-0.02em', marginBottom: '24px' }}>
                        Stay in the loop.
                    </h2>
                    <p style={{ fontSize: '18px', color: 'var(--text-secondary)', marginBottom: '48px', lineHeight: 1.6 }}>
                        Join 5,000+ revenue leaders getting our weekly brief on <br />
                        quality, intelligence, and operations excellence.
                    </p>

                    <form onSubmit={handleSubmit} style={{ 
                        display: 'flex', gap: '12px', background: 'var(--bg-page)', 
                        padding: '8px', borderRadius: '100px', border: '1px solid var(--border)',
                        maxWidth: '500px', margin: '0 auto', boxShadow: '0 10px 30px rgba(0,0,0,0.05)'
                    }}>
                        <input 
                            type="email" 
                            placeholder="your@email.com" 
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{
                                flex: 1,
                                background: 'transparent',
                                border: 'none',
                                padding: '0 24px',
                                fontSize: '15px',
                                color: 'var(--text-primary)',
                                outline: 'none'
                            }}
                        />
                        <button 
                            type="submit"
                            disabled={status === 'loading' || status === 'success'}
                            style={{
                                background: 'var(--accent)',
                                color: 'white',
                                border: 'none',
                                padding: '14px 32px',
                                borderRadius: '100px',
                                fontSize: '14px',
                                fontWeight: '700',
                                cursor: 'pointer',
                                transition: 'all 0.3s',
                                minWidth: '120px'
                            }}
                        >
                            {status === 'loading' ? 'Subscribing...' : status === 'success' ? 'Subscribed!' : 'Subscribe'}
                        </button>
                    </form>

                    <div style={{ minHeight: '24px', marginTop: '16px' }}>
                        {email.length > 0 && status === 'idle' && (
                            <motion.p 
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                style={{ color: 'var(--text-tertiary)', fontSize: '12px', fontWeight: '500' }}
                            >
                                We don't spam, don't worry.
                            </motion.p>
                        )}
                        {status === 'success' && (
                            <motion.p 
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                style={{ color: 'var(--success)', fontWeight: '600', fontSize: '14px' }}
                            >
                                Welcome to the community! Check your inbox soon.
                            </motion.p>
                        )}
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
